import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';

export interface SelectWeekDialogComponentData {
  buttonLabel: string;
  title: string;
  startDate: string;
  numWeeks: number;
}

export type SelectWeekDialogComponentResult = Week;

interface Week {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

@Component({
  selector: 'select-week-dialog',
  templateUrl: './select-week-dialog.component.html',
  styleUrls: ['./select-week-dialog.component.css']
})

export class SelectWeekDialogComponent implements OnInit {

  buttonLabel: string;
  weeks: Week[];
  selectedWeek: Week;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectWeekDialogComponentData,
    private dialog: MatDialogRef<SelectWeekDialogComponent>,
  ) { }

  ngOnInit() {

    this.buttonLabel = (this.data.buttonLabel) ? this.data.buttonLabel : 'No Button Label';
    // create weeks
    this.weeks = [];

    // Start on mondays!
    const currDay = moment(new Date(this.data.startDate));

    // How many calender weeks does this plan span?
    // If it doest land on a monday, we need an extra week for the offset
    const totalNumWeeks =
      (currDay.format('dddd') === 'Monday') ? this.data.numWeeks : this.data.numWeeks + 1;

    // current week iterator
    let currWeek = 1;

    // Start on mondays!
    currDay.startOf('isoWeek');

    // Builds weeks
    while (currWeek <= totalNumWeeks) {
      const week: Week = {
        startDate: currDay.clone(),
        endDate: currDay.clone().add(6, 'days')
      };
      this.weeks.push(week);
      currDay.add(7, 'days');
      currWeek++;
    }
  }

  formatWeek(week: Week) {
    const firstDay: moment.Moment = week.startDate;
    const lastDay: moment.Moment = week.endDate;
    return `${firstDay.format('M/D/YYYY')} - ${lastDay.format('M/D/YYYY')}`;
  }

  close() {
    this.dialog.close(this.selectedWeek);
  }

  cancel() {
    this.dialog.close();
  }
}
